import { Helmet } from "react-helmet-async";

interface PageSeoProps {
  readonly title: string;
  readonly description: string;
  readonly canonicalPath: string;
}

const baseSiteUrl = (import.meta.env.VITE_SITE_URL ?? "https://www.ceralia.it").replace(
  /\/$/,
  "",
);

const buildCanonicalUrl = (canonicalPath: string) => {
  if (canonicalPath.startsWith("http://") || canonicalPath.startsWith("https://")) {
    return canonicalPath;
  }

  const normalizedPath = canonicalPath.startsWith("/")
    ? canonicalPath
    : `/${canonicalPath}`;

  return `${baseSiteUrl}${normalizedPath}`;
};

const PageSeo = ({ title, description, canonicalPath }: PageSeoProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={buildCanonicalUrl(canonicalPath)} />
    </Helmet>
  );
};

export default PageSeo;
